import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useDispatch } from 'react-redux';
import Crop32Icon from '@mui/icons-material/Crop32';
import dbPlusIcon from "../../../logos/dbplus.png";
import GlobalSettings from "../../../logos/globalSettings.png";
import { setTruInkSelectedOption } from '../../../redux/slices/truInk';
function TruInkSubDrawer() {
      const dispatch = useDispatch();
      return (
            <List component="div" disablePadding>
                  <ListItem button sx={{ pl: 4 }} onClick={() => {
                        dispatch(setTruInkSelectedOption("TruInk Global Data"));
                  }}>
                        <ListItemIcon>
                              <img src={dbPlusIcon} style={{ height: "10%", width: "20%" }} />
                        </ListItemIcon>
                        <ListItemText primary="Global Data" style={{ marginLeft: "-25%" }} />
                  </ListItem>
                  <ListItem button sx={{ pl: 4 }} onClick={() => {
                        dispatch(setTruInkSelectedOption("TruInk Global Templates"));
                  }}>
                        <ListItemIcon>
                              <Crop32Icon />
                        </ListItemIcon>
                        <ListItemText primary="Global Templates" style={{ marginLeft: "-7%" }} />
                  </ListItem>
                  <ListItem button sx={{ pl: 4 }} onAbort={() => {
                        dispatch(setTruInkSelectedOption("TruInk Global Settings"));
                  }}>
                        <ListItemIcon>
                              <img src={GlobalSettings} style={{ height: "10%", width: "20%" }} />
                        </ListItemIcon>
                        <ListItemText primary="Global Settings" style={{ marginLeft: "-25%" }} />
                  </ListItem>
            </List>
      )
}

export default TruInkSubDrawer